import FormattedMessage from 'I18n/components/FormattedMessage';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import Raven from 'raven-js';
import { useState } from 'react';
import { createCTA } from 'web-interactives-data/api/WebInteractives';
import { getCtaEditorUrl, redirectTo } from 'web-interactives-data/utils/urlUtils';
import { ERROR, LOADING, SUCCESS, UNINITIALIZED } from '../../types/RequestState';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreateAndRedirectButton({
  template,
  redirectQueryParams,
  text,
  use,
  size,
  disabled
}) {
  const [state, setState] = useState(UNINITIALIZED);
  const onClick = () => {
    if (state !== UNINITIALIZED) {
      return;
    }
    setState(LOADING);
    createCTA(template).then(({
      id
    }) => {
      setState(SUCCESS);
      redirectTo(getCtaEditorUrl(id, redirectQueryParams || {}), {
        newTab: true
      });
    }).catch(e => {
      Raven.captureMessage(`Error creating meeting popup`, {
        extra: {
          template,
          error: e
        }
      });
      setState(ERROR);
    }).finally(() => {
      setTimeout(() => {
        setState(UNINITIALIZED);
      }, 3000);
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "integrations.shared.createAndRedirectButton.failureAlert"
    }),
    open: state === ERROR,
    children: /*#__PURE__*/_jsx(LoadingButton, {
      use: use || 'primary',
      size: size || 'medium',
      disabled: disabled,
      onClick: onClick,
      loading: state === LOADING,
      preventClicksOnLoading: true,
      resultIcon: state === SUCCESS ? SuccessIcon : RemoveIcon,
      children: text || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "integrations.shared.createAndRedirectButton.text"
      })
    })
  });
}